/**
 * @generated SignedSource<<68c7280d8c97fe42e68bd73c6009388e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AskCopilotMessageRole = "ASSISTANT" | "USER";
import { FragmentRefs } from "relay-runtime";
export type AskFellowPanelInner_ChatMessage_message$data = {
  readonly content: string;
  readonly contentForDisplay: string | null;
  readonly contentJson: any | null;
  readonly id: string;
  readonly isResponse: boolean;
  readonly pending: boolean;
  readonly role: AskCopilotMessageRole;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_RatingButtons_message" | "AskFellowPanelInner_ToolUseAndResult_use">;
  readonly " $fragmentType": "AskFellowPanelInner_ChatMessage_message";
};
export type AskFellowPanelInner_ChatMessage_message$key = {
  readonly " $data"?: AskFellowPanelInner_ChatMessage_message$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_ChatMessage_message">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowPanelInner_ChatMessage_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "role",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentJson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentForDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pending",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isResponse",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AskFellowPanelInner_ToolUseAndResult_use"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AskFellowPanelInner_RatingButtons_message"
    }
  ],
  "type": "AskCopilotMessage",
  "abstractKey": null
};

(node as any).hash = "352c6630880c3e593697ad407c8f1bd2";

export default node;
